import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RelatorioRiscoGaiolaRequest, RelatorioRiscoGaiolaResponse } from 'src/app/@shared/models/relatorio-risco-gaiola.model';
import { ParametrizacaoHubService } from 'src/app/services/parametrizacao-hub/parametrizacaoHub.service';
import { RelatorioRiscoGaiolaService } from 'src/app/services/relatorio-risco-gaiola/relatorio-risco-gaiola.service';
import { environment } from 'src/environments/environment';

const RECEPCIONADO = [
  { status: '', descricao: 'TODOS' },
  { status: true, descricao: 'SIM' },
  { status: 'false', descricao: 'NÃO' },
]

@Component({
  selector: 'app-relatorio-risco-gaiola',
  templateUrl: './relatorio-risco-gaiola.component.html',
  styleUrls: ['./relatorio-risco-gaiola.component.scss']
})
export class RelatorioRiscoGaiolaComponent implements OnInit {
  isLoading: boolean;
  isLoadingDownload: boolean;
  iatas: any[];
  selectRecepcionado: any;

  listaRelatorioRiscoGaiola: any[] = [];

  filtro: RelatorioRiscoGaiolaRequest;

  filterForm: FormGroup = new FormGroup({
    dataInicio: new FormControl('', [Validators.required]),
    dataFim: new FormControl('', [Validators.required]),
    iata: new FormControl(),
    manifesto: new FormControl(),
    nrt: new FormControl(),
    gaiola: new FormControl(),
    recepcionado: new FormControl(),
  })
  get dataInicio() { return this.filterForm.get('dataInicio').value; }
  get dataFim() { return this.filterForm.get('dataFim').value; }
  get iata() { return this.filterForm.get('iata').value; }
  get manifesto() { return this.filterForm.get('manifesto').value; }
  get nrt() { return this.filterForm.get('nrt').value; }
  get gaiola() { return this.filterForm.get('gaiola').value; }
  get recepcionado() { return this.filterForm.get('recepcionado').value; }

  private onDestroy = new Subject<void>();
  public filteredIatas: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public iataMultiFilter: FormControl = new FormControl();

  public paging = { index: 0, size: 10, length: 0 };
  displayedColumns: string[] = [
    'manifesto',
    'filialOrigem',
    'filialDestino',
    'iata',
    'qtdVolume',
    'usuarioManifestador',
    'dataInclusao',
    'usuarioRecepcao',
    'dataRecep',
    'codigoGaiola'
  ]

  constructor(
    private paramitrezacaoHubService: ParametrizacaoHubService,
    private relatorioRiscoGaiolaService: RelatorioRiscoGaiolaService,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.iniciarDatas();
    this.selectRecepcionado = RECEPCIONADO;
    this.listarIATAs();
  }

  iniciarDatas() {
    const filtroFim = new Date();
    const filtroInicio = new Date(filtroFim);
    filtroInicio.setDate(filtroInicio.getDate() - 10);
    this.filterForm.get('dataInicio').setValue(filtroInicio);
    this.filterForm.get('dataFim').setValue(filtroFim);
  }

  public listarIATAs() {
    this.paramitrezacaoHubService.selecionarTodasIATAs().subscribe(response => {
      this.iatas = response.filter(x => x.name && x.iataNomeFantasia).sort();
      this.iatas = Object.values(this.iatas.reduce((acc, cur) => Object.assign(acc, { [cur.name]: cur }), {}))
      this.filteredIatas.next(this.iatas.slice());
      this.iataMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() =>
          this.filtroGeral(
            this.iatas,
            this.iataMultiFilter,
            this.filteredIatas,
            'name',
            true
          )
        );
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar IATAs, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  listarRelatoriosRiscoGaiola() {
    this.isLoading = true;
    this.listaRelatorioRiscoGaiola = null;
    this.filtro = {
      dataInicio: this.dataInicio ? this.dataInicio.toISOString().split('T')[0] : null,
      dataFim: this.dataFim ? this.dataFim.toISOString().split('T')[0] : null,
      iata: (this.iata?.length && !this.iata.includes('') && this.iata) || null,
      numeroManifesto: this.manifesto,
      nrt: this.nrt,
      gaiola: this.gaiola,
      recepcionado: this.recepcionado,
      itensPorPagina: this.paging.size,
      paginaAtual: this.paging.index + 1
    }
    this.relatorioRiscoGaiolaService.listarRelatorioRiscoGaiola(this.filtro)
      .subscribe((response: RelatorioRiscoGaiolaResponse[]) => {
        this.listaRelatorioRiscoGaiola = response;
        response.length ? this.paging.length = response[0].totalCount : null;
      },
      (err: HttpErrorResponse) => {
        this.listaRelatorioRiscoGaiola = null;
        console.error(err);
        this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      })
      .add(() => this.isLoading = false)
  }

  private filtroGeral(filtro: any, multifilter: any, filtered: any, field: string, iata?: boolean) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      iata
        ? filtro.filter(response => `${response.name} - ${response.iataNomeFantasia}`.toLowerCase().indexOf(search) > -1)
        : filtro.filter(response => response[field].toLowerCase().indexOf(search) > -1)
    );
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data)
    const blob = new Blob([arrBuffer], {
      type
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcel() {
    this.isLoadingDownload = true;
    this.relatorioRiscoGaiolaService.exportarExcel(this.filtro).subscribe(
      (response: any) => {
        this.gerarArquivo(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        )
      },
      (err: HttpErrorResponse) => console.error('erro', err),
      () => this.isLoadingDownload = false
    )
  }

  clearFields() {
    this.listaRelatorioRiscoGaiola = null;
    this.filterForm.reset();
    this.iniciarDatas();
    this.filterForm.updateValueAndValidity();
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;

    this.listarRelatoriosRiscoGaiola();
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
